export default function urlify(text: string) {
    const urlRegex = /(https?:\/\/[^\s]+)/g;

    return text.replace(
        urlRegex,
        (url: string) => `<a href="${url}" target = "_blank">${url}</a>`
    );
}
